
import React from 'react'
import { BrowserRouter, Route, Switch } from 'react-router-dom'
import { FetchSettings } from './settings'
import { PropTypes } from 'prop-types'
import './scss/style.scss'
import { Provider } from 'react-redux'
import store from './store/index'
import ScrollToTop from './utils/ScrollToTop'

// Containers
const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'))

App.propTypes = {
  authState: PropTypes.string,
}

function App(props) {
  const oidcAuth = props.oidcAuth
  const signout = props.signout
  if (props.authState === 'signedIn') {
    return (
      <Provider store={store}>
        <BrowserRouter>
          <ScrollToTop>
            <FetchSettings>
              <Switch>
              <Route path="/" name="Home" render={(props) => <DefaultLayout oidcAuth={oidcAuth} signout={signout} {...props} />} />
              </Switch>
            </FetchSettings>
          </ScrollToTop>
        </BrowserRouter>
      </Provider>
    )
  } else {
    return null
  }
}

export default App
